import React from 'react';
import SliderCarousel from '../components/SliderCarousel';
import FeatureBox from '../components/FeatureBox';
import Footer from '../components/footer';
import CreatorsList from '../components/CreatorsList';
import RecentlyListedNft from '../components/RecentlyListedNft';

const homethree = () => (
  <div>
    {/* <section className="jumbotron no-bg no-bottom">
      <div className='container-fluid'>
        <div className='row'>
          <SliderCarousel />
        </div>
      </div>
    </section> */}

    <section className='container'>
      <div className='row'>
        <div className='col-lg-12'>
          <h2 className='style-2'>New Items</h2>
        </div>
      </div>
      <RecentlyListedNft />
    </section>

    <section className='container no-top'>
      <div className='row'>
        <div className='col-lg-12'>
          <h2 className='style-2'>Top Seller</h2>
        </div>
        <div className='col-lg-12'>
          <CreatorsList />
        </div>
      </div>
    </section>

    <section className='container no-top'>
      <div className='row'>
        <div className='col-lg-12'>
          <h2 className='style-2'>Create and sell</h2>
        </div>
      </div>
      <div className='container px-0'>
        <FeatureBox />
      </div>
    </section>

    <Footer />

  </div>
);
export default homethree;